import { DocumentSemanticSearchCurationMode } from '../../graphql-types'

/** Default GraphQL flags for Mosaic search (no UI toggles). */
export const MOSAIC_SEARCH_INCLUDE_SUMMARY = true
export const MOSAIC_SEARCH_INCLUDE_TRANSITIONS = true

/**
 * Curation mode presets for Semantic Stitch (UI picker).
 * Preset IDs match Brooklyn `DocumentSemanticSearchCurationMode` enum values.
 */

export const CURATION_MODE_BEST_MATCHES = DocumentSemanticSearchCurationMode.BestMatches
export const CURATION_MODE_WIDE_LENS = DocumentSemanticSearchCurationMode.WideLens
export const CURATION_MODE_DEEP_DIVE = DocumentSemanticSearchCurationMode.DeepDive
export const CURATION_MODE_LEARNING_PATH = DocumentSemanticSearchCurationMode.LearningPath

export const DEFAULT_CURATION_MODE = CURATION_MODE_BEST_MATCHES

/** Curation modes rendered in the preset picker. */
export const CURATION_MODE_PRESETS = [
  CURATION_MODE_BEST_MATCHES,
  CURATION_MODE_WIDE_LENS,
  CURATION_MODE_DEEP_DIVE,
  CURATION_MODE_LEARNING_PATH,
]

/** Static text keys in `semanticStitchPage` for preset card titles. */
export const CURATION_MODE_LABEL_KEY = {
  [CURATION_MODE_BEST_MATCHES]: 'presetBestMatches',
  [CURATION_MODE_WIDE_LENS]: 'presetWideLens',
  [CURATION_MODE_DEEP_DIVE]: 'presetDeepDive',
  [CURATION_MODE_LEARNING_PATH]: 'presetLearningPath',
}

/** Static text keys in `semanticStitchPage` for preset card subtitles. */
export const CURATION_MODE_DESC_KEY = {
  [CURATION_MODE_BEST_MATCHES]: 'presetBestMatchesDesc',
  [CURATION_MODE_WIDE_LENS]: 'presetWideLensDesc',
  [CURATION_MODE_DEEP_DIVE]: 'presetDeepDiveDesc',
  [CURATION_MODE_LEARNING_PATH]: 'presetLearningPathDesc',
}

/** Duration preset IDs for Mosaic time-budget pills (maps to `maxResults`). */
export const DURATION_PRESET_5MIN = '5min'
export const DURATION_PRESET_10MIN = '10min'
export const DURATION_PRESET_15MIN = '15min'
export const DURATION_PRESET_20MIN = '20min'
export const DURATION_PRESET_30MIN = '30min'

export const DEFAULT_DURATION_PRESET = DURATION_PRESET_15MIN

/** Duration presets rendered in the search form (time-first labels; subtext = clip ceiling). */
export const DURATION_PRESETS = [
  { id: DURATION_PRESET_5MIN, maxResults: 4 },
  { id: DURATION_PRESET_10MIN, maxResults: 7 },
  { id: DURATION_PRESET_15MIN, maxResults: 10 },
  { id: DURATION_PRESET_20MIN, maxResults: 15 },
  { id: DURATION_PRESET_30MIN, maxResults: 20 },
]

/** Static text keys in `semanticStitchPage` for duration pill primary labels. */
export const DURATION_LABEL_KEY = {
  [DURATION_PRESET_5MIN]: 'duration5min',
  [DURATION_PRESET_10MIN]: 'duration10min',
  [DURATION_PRESET_15MIN]: 'duration15min',
  [DURATION_PRESET_20MIN]: 'duration20min',
  [DURATION_PRESET_30MIN]: 'duration30min',
}

/** Static text keys in `semanticStitchPage` for duration pill subtext (clip ceiling). */
export const DURATION_SUBLABEL_KEY = {
  [DURATION_PRESET_5MIN]: 'duration5minSub',
  [DURATION_PRESET_10MIN]: 'duration10minSub',
  [DURATION_PRESET_15MIN]: 'duration15minSub',
  [DURATION_PRESET_20MIN]: 'duration20minSub',
  [DURATION_PRESET_30MIN]: 'duration30minSub',
}

/** Resolve a duration preset by id; falls back to default when unknown. */
export function getDurationPreset (presetId) {
  return DURATION_PRESETS.find((p) => p.id === presetId)
    ?? DURATION_PRESETS.find((p) => p.id === DEFAULT_DURATION_PRESET)
}
